import { Button } from '@/common/ui/button'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function NavigateBackButton() {
	const navigate = useNavigate()

	return (
		<Button
			onClick={() => navigate(-1)}
			variant="outline"
			className="flex items-center gap-2 border"
		>
			<ArrowLeft className="h-4 w-4" />
			ย้อนกลับ
		</Button>
	)
}
